<template>
  <Delete />
</template>

<script>
import Delete from '../components/templates/Delete.vue'

export default {
  components: {
    Delete
  }
}
</script>
